import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

function Swap() {
    const [fromAsset, setFromAsset] = useState('USDT');
    const [toAsset, setToAsset] = useState('RAINO');
    const [fromAmount, setFromAmount] = useState('');
    const [toAmount, setToAmount] = useState('');
    const [isData, setIsData] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isRotated, setIsRotated] = useState(false);
    const coinPrice = localStorage.getItem("adminCoinPrice");

    const userId = localStorage.getItem("id");

    const switchSwapAssets = () => {
        const tempFromAsset = fromAsset;
        const tempFromAmount = fromAmount;
        const tempToAmount = toAmount;

        setFromAsset(toAsset);
        setToAsset(tempFromAsset);
        setFromAmount(tempToAmount);
        setToAmount(tempFromAmount);
        setIsRotated(!isRotated);
    };

    const calculateAmount = (amount) => {
        const price = parseFloat(coinPrice) || 0;

        if (!amount || amount === '' || price === 0) {
            setFromAmount(amount);
            setToAmount('');
            return;
        }

        const numAmount = parseFloat(amount);

        if (isNaN(numAmount) || numAmount < 0) {
            setFromAmount(amount);
            setToAmount('');
            return;
        }

        setFromAmount(amount);

        if (fromAsset === 'USDT') {
            const amountTo = numAmount / price;
            setToAmount(amountTo.toFixed(6));
        } else if (fromAsset === 'RAINO') {
            const amountTo = numAmount * price;
            setToAmount(amountTo.toFixed(6));
        }
    };

    const startSwap = async () => {
        if (!fromAmount || parseFloat(fromAmount) <= 0) {
            toast.error('Please enter a valid amount');
            return;
        }

        if (!userId) {
            toast.error('User not authenticated');
            return;
        }

        if (!coinPrice || parseFloat(coinPrice) <= 0) {
            toast.error('Coin price not available');
            return;
        }

        try {
            const response = await axios.post(
                `https://rainocoin.com/api/swapAsset.php`,
                {
                    userid: userId,
                    fromAsset: fromAsset,
                    fromAmount: fromAmount,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const data = response.data;

            if (data.status) {
                toast.success(data.message);
                setFromAmount('');
                setToAmount('');
                await fetchHistory(); // Refresh swap history
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            console.error('API Error:', error.message);
            toast.error('Network or server error');
        }
    };

    const fetchHistory = async () => {
        if (!userId) return;

        try {
            const response = await axios.get(`https://rainocoin.com/api/swap_data.php`, {
                params: { userid: userId }
            });

            const result = response.data;

            if (result.status && Array.isArray(result.data)) {
                setTableData(result.data);
                setIsData(result.data.length > 0);
            } else {
                setIsData(false);
            }
        } catch (error) {
            console.error('Error fetching swap history:', error.message);
            setIsData(false);
        }
    };

    useEffect(() => {
        fetchHistory();
    }, []);

    return (
        <>
            <div className="app-header st1">
                <Auth />
                <ToastContainer />
                <div className="tf-container">
                    <div className="tf-topbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"><i className="icon-left white_color"></i></Link>
                        <h3 className="white_color">Swap</h3>
                    </div>
                </div>
            </div>

            <div className="card-secton topup-content">
                <div className="tf-container">
                    <div className="tf-balance-box">
                        <div className="tf-spacing-16"></div>
                        <div className="tf-form">
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Enter {fromAsset}</label>
                                <input
                                    type="number"
                                    className="password-input"
                                    value={fromAmount}
                                    placeholder={`Enter ${fromAsset} Amount`}
                                    onChange={(e) => calculateAmount(e.target.value)}
                                />
                            </div>

                            <div className="mt-5 mb-5 text-center">
                                <div className="swap-icon-container" onClick={switchSwapAssets}>
                                    <img
                                        className={`swap-icon ${isRotated ? 'rotated' : ''}`}
                                        style={{ width: "40px", height: "auto" }}
                                        src="assets/images/icon-socials/swapIcon.png"
                                        alt="Swap"
                                    />
                                </div>
                            </div>

                            <div className="group-input auth-pass-input last mt-3">
                                <label>Enter {toAsset}</label>
                                <input
                                    type="number"
                                    className="password-input"
                                    value={toAmount}
                                    placeholder={`Enter ${toAsset} Amount`}
                                    readOnly
                                />
                            </div>

                            <div className="group-input auth-pass-input last mt-5 text-center">
                                <button className="tf-btn accent large" onClick={startSwap}>Swap Asset</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="app-wrap">
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <h4 className="fw_5 mb-3">History</h4>
                            <div className="group-trading-history mb-5">
                                {isData ? (
                                    <div>
                                        {tableData.map((item, index) => (
                                            <Link key={index} className="tf-trading-history" to="#">
                                                <div className="inner-left">
                                                    <div className="icon-box">
                                                        <i className="icon icon-mobile" />
                                                    </div>
                                                    <div className="content">
                                                        <h4>
                                                            {item.from_amount} {item.from_asset} ➜ {item.to_amount} {item.to_asset}
                                                        </h4>
                                                        <p>{item.date_time}</p>
                                                    </div>
                                                </div>
                                                <span className={`num-val ${item.status === 'success' ? 'success_color' : 'error_color'}`}>
                                                    {item.status}
                                                </span>
                                            </Link>
                                        ))}
                                    </div>
                                ) : (
                                    <div>
                                        <Link className="tf-trading-history" to="#">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>No Data Found</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .swap-icon-container {
                    cursor: pointer;
                    display: inline-block;
                    padding: 10px;
                    border-radius: 50%;
                    transition: background-color 0.2s ease;
                }

                .swap-icon-container:hover {
                    background-color: rgba(0, 0, 0, 0.1);
                }

                .swap-icon {
                    transition: transform 0.3s ease;
                    display: block;
                }

                .swap-icon.rotated {
                    transform: rotate(180deg);
                }
            `}</style>
        </>
    );
}

export default Swap;
